import * as Types from '@/types';

import * as Apollo from '@apollo/client';
import { gql } from '@apollo/client';
import { useLazyQuery } from '@/hooks/use-lazy-query';
import { useWrappedQuery } from '@/hooks/use-wrapped-query';
const defaultOptions = {} as const;

export const SalesPortalChatDynamicConfigDocument = gql`
  query SalesPortalChatDynamicConfig($chatUUID: uuid!) {
    employee_chats(where: { chat_uuid: { _eq: $chatUUID } }, limit: 1) {
      chat_uuid
      chat_dynamic_config
      supplier_uuid
    }
  }
`;
export function useSalesPortalChatDynamicConfigQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.SalesPortalChatDynamicConfigQuery,
    Types.SalesPortalChatDynamicConfigQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Types.SalesPortalChatDynamicConfigQuery,
    Types.SalesPortalChatDynamicConfigQueryVariables
  >(SalesPortalChatDynamicConfigDocument, options);
}
export function useSalesPortalChatDynamicConfigLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.SalesPortalChatDynamicConfigQuery,
    Types.SalesPortalChatDynamicConfigQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.SalesPortalChatDynamicConfigQuery,
    Types.SalesPortalChatDynamicConfigQueryVariables
  >(SalesPortalChatDynamicConfigDocument, options);
}
export type SalesPortalChatDynamicConfigQueryHookResult = ReturnType<
  typeof useSalesPortalChatDynamicConfigQuery
>;
export type SalesPortalChatDynamicConfigLazyQueryHookResult = ReturnType<
  typeof useSalesPortalChatDynamicConfigLazyQuery
>;
export type SalesPortalChatDynamicConfigQueryResult = Apollo.QueryResult<
  Types.SalesPortalChatDynamicConfigQuery,
  Types.SalesPortalChatDynamicConfigQueryVariables
>;

/**
 * Wrapped version of useGeneratedSalesPortalChatDynamicConfigQuery using Pepper's useWrappedQuery
 */
export function useGeneratedSalesPortalChatDynamicConfigQuery(
  options?: Apollo.QueryHookOptions<
    Types.SalesPortalChatDynamicConfigQuery,
    Types.SalesPortalChatDynamicConfigQueryVariables
  >,
) {
  return useWrappedQuery<
    Types.SalesPortalChatDynamicConfigQuery,
    Types.SalesPortalChatDynamicConfigQueryVariables
  >(SalesPortalChatDynamicConfigDocument, options);
}

/**
 * Wrapped version of useGeneratedSalesPortalChatDynamicConfigLazyQuery using Pepper's useLazyQuery
 */
export function useGeneratedSalesPortalChatDynamicConfigLazyQuery(
  lazyOptions?: Omit<
    Apollo.QueryOptions<Types.SalesPortalChatDynamicConfigQueryVariables>,
    'query'
  >,
) {
  return useLazyQuery<
    Types.SalesPortalChatDynamicConfigQuery,
    Types.SalesPortalChatDynamicConfigQueryVariables
  >(SalesPortalChatDynamicConfigDocument, lazyOptions);
}
